import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AutomationScheduleTemplateBody from "components/AutomationComponents/AutomationScheduleTemplatesBody/AutomationScheduleTemplatesBody";

const AutomationScheduleTemplates = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Automation Schedule Templates";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="automation" />

      <AutomationScheduleTemplateBody />
    </main>
  );
};

export default AutomationScheduleTemplates;
